import React from 'react'
import type { Offer } from 'types/entities/Offer'
import type { OfferCalculation } from 'types/entities/OfferCalculation'

interface OfferDetailContextValue {
    selectedOffer: Offer
    targetCalculation?: OfferCalculation
    isExportingPdf: boolean
    setIsExportingPdf: (val: boolean) => void
    onClose?: () => void
}

const OfferDetailContext = React.createContext<OfferDetailContextValue | null>(null)

export const OfferDetailProvider: React.FC<{
    value: OfferDetailContextValue
    children: React.ReactNode
}> = ({ value, children }) => {
    return <OfferDetailContext.Provider value={value}>{children}</OfferDetailContext.Provider>
}

export const useOfferDetailContext = () => {
    const context = React.useContext(OfferDetailContext)
    if (!context) {
        throw new Error('useOfferDetailContext must be used inside OfferDetailProvider')
    }
    return context
}

export const useOptionalOfferDetailContext = () => {
    return React.useContext(OfferDetailContext)
}
